import { createContext } from 'react';

// { nodeId: [{ studentId, studentName }] } for the classroom canvas. Lives in
// its own context so live position updates flow to nodes WITHOUT recreating
// ReactFlow's nodeTypes map — nodeTypes must stay module-level constants or
// ReactFlow remounts every node on each change.
const StudentPositionsContext = createContext({});

export default StudentPositionsContext;
